import { CarrierAssignDetails } from '@components/_SiteWide/AuditHistory/CarrierAssignDetails'
import { Texto } from '@gravitate-js/excalibrr'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { Button, Col, Row } from 'antd'
import { useMemo, useState } from 'react'

import { actionIcons, auditActions } from '../../../constants/auditHistory'
import { CompartmentDetails } from './CompartmentDetails'
import { DefaultDetailsContainer } from './DefaultDetailsContainer'
import { DriverDropOverrideDetails } from './DriverDropOverrideDetails'
import { SupplyActionDetails } from './SupplyActionDetails'
import { DestinationUpdated } from './DestinationUpdated'
import { SupplyDifferences } from './SupplyDifferences'
import { DeliveryReportDetails } from './DeliveryReportDetails'

export function HistoryItem({ action, isRequestedChangeAudit }) {
  const [viewingDetails, setViewingDetails] = useState(false)
  const details = { ...action.extra_data }
  const hideKeys = ['number', 'username']
  const detailKeys = Object.keys(details).filter(
    (key) => !hideKeys.includes(key) && !key.includes('id') && !key.includes('_local')
  )

  const enableShowDetails = useMemo(() => {
    if (action.action === 'cancel' && !action.extra_data.note) return false
    return detailKeys.length > 0
  }, [detailKeys, action])

  const handleViewDetails = () => {
    setViewingDetails(!viewingDetails)
  }

  const isModelCreated = action.action === 'create' && action.extra_data.model_created
  const isUserCreated = action.action === 'create' && action.extra_data.model_created === false

  return (
    <>
      <Row flex={1} align='middle'>
        <Col span={3}>
          {actionIcons[isModelCreated ? 'created_by_model' : isUserCreated ? 'created_by_user' : action.action]}
        </Col>
        <Row flex={1} align='middle' style={{ flexGrow: 1 }}>
          <Col span={12} align='left'>
            <Texto category='h5' weight='bold' style={{ textTransform: 'capitalize' }}>
              {auditActions[action.action] ?? 'Order Updated'}
            </Texto>
          </Col>
          <Col span={12} align='right'>
            {enableShowDetails && (
              <Button type='link' style={{ paddingRight: 0 }} onClick={handleViewDetails}>
                {!viewingDetails ? 'View Details' : 'Hide Details'}
              </Button>
            )}
          </Col>

          <Col span={12}>{formatters.DATE_TIME(new Date(action.date))}</Col>
          <Col span={12} align='right'>
            {action.extra_data?.username || 'Gravitate'}
          </Col>
        </Row>
      </Row>

      {viewingDetails && (
        <DetailsContent
          action={action.action}
          details={details}
          keys={detailKeys}
          isRequestedChangeAudit={isRequestedChangeAudit}
        />
      )}
    </>
  )
}

function DetailsContent({ action, details, keys, isRequestedChangeAudit }) {
  switch (action) {
    case 'update volume':
      return (
        <CompartmentDetails
          oldCompartmentValues={details.old_compartments}
          newCompartmentValues={details.new_compartments}
        />
      )
    case 'update product':
      return (
        <CompartmentDetails
          oldCompartmentValues={details.old_compartments}
          newCompartmentValues={details.new_compartments}
        />
      )
    case 'update destination':
      return (
        <DestinationUpdated
          oldCompartmentValues={
            details.old_compartments &&
            details.old_compartments.map((comp) => comp.targets.map((target) => target.location_name).join(' , '))
          }
          newCompartmentValues={
            details.new_compartments &&
            details.new_compartments.map((comp) => comp.targets.map((target) => target.location_name).join(' , '))
          }
          oldStopValues={details.old_stop_order}
          newStopValues={details.new_stop_order}
        />
      )
    case 'update supply option':
      return <SupplyActionDetails details={details} detailKeys={keys} isRequestedChangeAudit={isRequestedChangeAudit} />
    case 'smart supply v2':
      return <SupplyDifferences oldSupply={details.old_supply_option} newSupply={details.new_supply_option} />
    case 'carrier assign':
      return <CarrierAssignDetails details={details} detailKeys={keys} />
    case 'carrier unassign':
      return <CarrierAssignDetails details={details} detailKeys={keys} />
    case 'driver drop override':
      return <DriverDropOverrideDetails details={details} detailKeys={keys} />
    case 'order_added':
    case 'order_removed':
    case 'delivery_added':
    case 'delivery_removed':
    case 'created':
    case 'approved':
    case 'unapproved':
      return <DeliveryReportDetails details={details} detailKeys={keys} />
    default:
      return <DefaultDetailsContainer details={details} detailKeys={keys} />
  }
}
